<script>
  export let width = 'auto';
</script>

<div class="container" style={`width: ${width};`}>
  <slot />
</div>

<style>
  .container {
    display: flex;
    flex-direction: column;
    align-items: flex-start;
    padding: 28px 30px;
    border: 1px solid #33414f;
    box-sizing: border-box;
    border-radius: 10px;
    background: #0b1220;
  }
</style>
